import { useEffect, useState, memo, useRef, useCallback } from 'react';
import DragDrawer from '@/sub-luca-plugin/components/drag-drawer';
import KnowledgePointsRender, { IKnowledgePointsRenderProps } from '../knowledge-points-render';
import { eventBusExample } from '@/sub-luca-plugin/utils/class-example';
import { INoticeData } from '@/sub-luca-plugin/types';

const KnowledgeSliceRightDrawer = () => {
    const currentCollectStatus = useRef<boolean>();
    const callbacksRef = useRef<Record<string, (data: any) => void>>();
    const [visible, setVisible] = useState(false);
    const [params, setParams] = useState<IKnowledgePointsRenderProps>({});

    const handleCollectActionChange = useCallback((status: boolean) => {
        currentCollectStatus.current = status;
    }, []);

    const handleCloseDrawer = () => {
        callbacksRef.current?.onClose({ collectFlag: currentCollectStatus.current });
        setVisible(false);
        setTimeout(() => setParams({}), 500);
    };

    useEffect(() => {
        eventBusExample.subscribe('KnowledgePointsRightDrawer', ({ type, params = {}, callbacks }: INoticeData) => {
            const { title, content, recordId, projectId, subjectId, twoLevelSubjectId } = params;
            switch (type) {
                case 'open':
                    callbacksRef.current = callbacks;
                    setParams({ title, content, recordId, projectId, subjectId, twoLevelSubjectId });
                    setVisible(true);
                    break;
                default:
                    handleCloseDrawer();
                    break;
            }
        });
    }, []);

    return (
        <DragDrawer width={375} open={visible} onClose={handleCloseDrawer}>
            <KnowledgePointsRender {...params} onCollectStatusChange={handleCollectActionChange} onClose={handleCloseDrawer} />
        </DragDrawer>
    );
};

export default memo(KnowledgeSliceRightDrawer);
